/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Navigate, Route, useSearchParams } from 'react-router-dom';
import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';
import { AICA_SETTINGS_PATH } from '../constants';

const AiGeneratedCodeApp = lazyLoadComponent(() => import('./settings/AiGeneratedCodeApp'));

export const aicaSettingsRoutes = () => {
  return (
    <>
      <Route
        element={<OldAiGeneratedCodeRedirect />}
        path={`extension/developer-server/${AICA_SETTINGS_PATH}`}
      />
      <Route element={<AiGeneratedCodeApp />} path={AICA_SETTINGS_PATH} />
    </>
  );
};

function OldAiGeneratedCodeRedirect() {
  const [searchParams] = useSearchParams();
  return (
    <Navigate
      replace
      to={{
        pathname: `/project/${AICA_SETTINGS_PATH}`,
        search: searchParams.toString(),
      }}
    />
  );
}
